import { jsx as _jsx } from "react/jsx-runtime";
import Status from '@ingka/status';
export default ({ statusColor, small, label, statusDotPosition }) => (_jsx(Status, { statusColor: statusColor, small: small, label: label, statusDotPosition: statusDotPosition }));
//# sourceMappingURL=SkapaStatus.js.map